import axios, { BASE_URL } from "../axios";
import BaseModel from "./baseModel";

export default class UserModel extends BaseModel {
  static endPoint = "users/";

  static update(body) {
    return axios.put(BASE_URL + this.endPoint, body);
  }

  static updatePassword(body) {
    return axios.post(BASE_URL + this.endPoint + "update-password", body);
  }

  static getAllByRole(role) {
    return axios.get(BASE_URL + this.endPoint + `get-all?role=${role}`);
  }

  static disable(id) {
    return axios.put(BASE_URL + this.endPoint + `${id}/disable`);
  }
}
